var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@templates/components/molecules/favoriteButton.html.njk"] = require( "@templates/components/molecules/favoriteButton.html.njk" );
dependencies["@templates/components/atoms/image.html.njk"] = require( "@templates/components/atoms/image.html.njk" );
dependencies["@naturehouse/design-system/components/protons/icon/Icon.macro.njk"] = require( "@naturehouse/design-system/components/protons/icon/Icon.macro.njk" );




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/molecules/card-small.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("@templates/components/molecules/favoriteButton.html.njk", false, "templates/components/molecules/card-small.html.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("favoriteButton", t_1);
output += "\n";
env.getTemplate("@templates/components/atoms/image.html.njk", false, "templates/components/molecules/card-small.html.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("image", t_4);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/protons/icon/Icon.macro.njk", false, "templates/components/molecules/card-small.html.njk", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("iconTemplate", t_7);
output += "\n\n";
var macro_t_10 = runtime.makeMacro(
["props"], 
[], 
function (l_props, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("props", l_props);
var t_11 = "";t_11 += "\n    <article class=\"nh-card--small\" data-house-id=\"";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"house")),"id"), env.opts.autoescape);
t_11 += "\" data-house-title=\"";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"house")),"title"), env.opts.autoescape);
t_11 += "\">\n        <div class=\"nh-card--small__image-container\">\n            <a class=\"nh-card--small__anchor\" href=\"";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"house")),"websiteUrl"), env.opts.autoescape);
t_11 += "\" target=\"_blank\">\n                <picture>\n                    ";
t_11 += runtime.suppressValue((lineno = 9, colno = 35, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "image")),"render"), "image[\"render\"]", context, [{"src": runtime.memberLookup((runtime.memberLookup((l_props),"house")),"imageUrl") + "" + ",fit=cover","alt": runtime.memberLookup((runtime.memberLookup((l_props),"house")),"title"),"classes": ["nh-card--small__image"],"loading": "lazy","width": 374,"height": 250}])), env.opts.autoescape);
t_11 += "\n                </picture>\n            </a>\n\n            ";
t_11 += runtime.suppressValue((lineno = 20, colno = 36, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "favoriteButton")),"render"), "favoriteButton[\"render\"]", context, [runtime.memberLookup((l_props),"house")])), env.opts.autoescape);
t_11 += "\n        </div>\n        <header class=\"nh-card--small__header\">\n            <a href=\"";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"house")),"websiteUrl"), env.opts.autoescape);
t_11 += "\" target=\"_blank\">\n                <h3>";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"house")),"title"), env.opts.autoescape);
t_11 += "</h3>\n            </a>\n            <div class=\"nh-card--small__subtitle\">";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"house")),"locationTitle"), env.opts.autoescape);
t_11 += "</div>\n            <div class=\"nh-card--small__persons\">\n                ";
t_11 += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 30, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "iconTemplate")),"render"), "iconTemplate[\"render\"]", context, [{"name": "user","size": "1"}]))), env.opts.autoescape);
t_11 += "\n                ";
t_11 += runtime.suppressValue(runtime.memberLookup((l_props),"icon_text"), env.opts.autoescape);
t_11 += "\n            </div>\n        </header>\n        <footer class=\"nh-card--small__footer\">\n            <div class=\"nh-card--small__footer-left\">\n                <p>";
t_11 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((l_props),"footer")),"text_left_1")), env.opts.autoescape);
t_11 += "</p>\n                <p>";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"footer")),"text_left_2"), env.opts.autoescape);
t_11 += "</p>\n            </div>\n            <a\n                class=\"nh-button nh-button--primary\"\n                href=\"";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"house")),"websiteUrl"), env.opts.autoescape);
t_11 += "\"\n                target=\"_blank\"\n            >\n                ";
t_11 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_props),"translations")),"visit"), env.opts.autoescape);
t_11 += "\n            </a>\n        </footer>\n    </article>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_11);
});
context.addExport("render");
context.setVariable("render", macro_t_10);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/molecules/card-small.html.njk"] , dependencies)